import { render, staticRenderFns } from "./dislikeFeedbackForm.vue?vue&type=template&id=19df70c1&scoped=true&"
import script from "./dislikeFeedbackForm.vue?vue&type=script&lang=js&"
export * from "./dislikeFeedbackForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19df70c1",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QOptionGroup,QSlideTransition,QInput,QCircularProgress});
